import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

export interface TradeUploadWizardContext {
    selectedTrade: TradeAndTradeProposalDto[];
    selectedType: TradeType;
    choice: SecondaryStatusChange;
    comment: string;
}

class UploadWizardComponentCtrl implements ng.IController {
    public readonly WIZARD_NAME = 'Trade / Trade proposal status upload';
    public wizard: mgoAngularWizard.Wizard<any>;

    constructor(
        private WizardHandler: mgoAngularWizard.WizardHandler<TradeUploadWizardContext>
    ) {}

    $doCheck(): void {
        if (this.wizard) {
            return;
        }

        let wizard: mgoAngularWizard.Wizard<any> = this.WizardHandler.wizard(
            this.WIZARD_NAME
        );

        if (wizard) {
            this.wizard = wizard;
            this.wizard.context = {};
        }
    }
}

angular.module('app').component('pkpTradeUploadWizard', {
    controller: UploadWizardComponentCtrl,
    template: require('app/trade-upload-wizard/trade-upload-wizard.component.html'),
    bindings: {}
});
